<template>
  <div class="fullprog">
    <div class="profile_page">
      <div class="profile_header">
        <div class="profile_title">Bien 2</div>
        <div class="profile_title1">venue</div>
        <div class="profile_circle"></div>
        <div class="profile_circle1"></div>
        <div class="profile_circle2"></div>
      </div>
      <div class="profile_form">
        <div class="nom_prenom">
          <input
            type="text"
            v-model="nom"
            class="profile_input"
            placeholder="Nom"
            style="width: 49%"
          />
          <input
            type="text"
            v-model="prenom"
            class="profile_input"
            placeholder="Prenom"
            style="width: 49%"
          />
        </div>
        <!--<input type="text" v-model="tel" class="profile_input" placeholder="tel">
                <input type="text" v-model="adresse" class="profile_input" placeholder="Adresse">-->
        <input
          type="text"
          v-model="email"
          class="profile_input"
          placeholder="email"
        />
        <input
          type="password"
          v-model="password"
          class="profile_input"
          placeholder="Mot de passe"
        />
        <input
          type="password"
          v-model="passwordconfirm"
          class="profile_input"
          placeholder="Confirmation du mot de passe"
        />
        <p class="profile_error_message" style="color: red;padding :5px 0;" v-if="password !== passwordconfirm">
      Mots de passes non identiques.
    </p>
        <button class="profile_button" @click="onSubmit()">
          Sign Up <span class="profile_button_circle"></span>
        </button>
      </div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  name: "Signup",
  data() {
    return {
      nom: "",
      prenom: "",
      tel: "",
      adresse: "",
      email: "",
      password: "",
      passwordconfirm: "",
    };
  },
  methods: {
    ...mapActions(["register", "loginProg", "getClientProg"]),
    async onSubmit() {
      const form = {
        nom: this.nom,
        prenom: this.prenom,
        email: this.email,
        tel: this.tel,
        adresse: this.adresse,
        password: this.password,
        passwordconfirm: this.passwordconfirm,
      };
      const formlogin = {
        email: this.email,
        password: this.password,
      };
      if (this.password !== this.passwordconfirm){
        return;
      }
      this.register(form)
        .then(()=>{ 
          this.loginProg(formlogin)})
        // .then((res) => {
        //   if (res.ok) {
        //     this.getClientProg();
        //     console.log(res.client);
        //   }
        // })
        .then(()=>{
          this.$modal.hide("login")
          setTimeout(() => {
            
            this.$modal.show("profile")
          }, 600);
        });

      // this.router.push('/login')
    },
  },
};
</script>

<style scoped>
.fullprog {
  width: 100%;
  box-sizing: border-box;
  background: transparent;
}

.profile_page {
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.profile_header {
  color: #fff;
  flex-direction: column;
  flex: 0;
  padding-top: 20px;
  justify-content: center;
  align-items: flex-start;
  padding-left: 24px;
  position: relative;
  margin: 0 0 20px;
  min-height: fit-content;
}

.profile_title {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.profile_title1 {
  font-size: 32px;
  font-weight: 700;
  transform: none;
  position: relative;
  bottom: 0;
  color: rgba(255,255,255,0.5);
  letter-spacing: -0.5px;
}

.profile_circle,
.profile_circle1,
.profile_circle2 {
  display: none;
}

.profile_form {
  flex: 2;
  display: flex;
  flex-direction: column;
  padding: 0px 24px;
  padding-bottom: 40px;
}

.profile_input {
  padding: 14px 18px;
  background: rgba(255,255,255,0.08);
  border: 1.5px solid rgba(255,255,255,0.15);
  border-radius: 12px;
  margin-bottom: 12px;
  font-size: 15px !important;
  text-align: center;
  color: #fff;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
}
.profile_input::placeholder {
  color: rgba(255,255,255,0.4);
}
.profile_input:focus {
  border-color: #D4714E;
  background: rgba(255,255,255,0.12);
}
.nom_prenom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  gap: 10px;
}
.profile_button {
  padding: 15px;
  background: linear-gradient(135deg, #D4714E, #C0603F);
  border-radius: 14px;
  margin-bottom: 12px;
  font-size: 16px !important;
  font-weight: 600;
  text-align: center;
  color: #fff;
  text-transform: capitalize;
  border: none;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(212,113,78,0.35);
  transition: transform 0.2s, box-shadow 0.2s;
}
.profile_button:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(212,113,78,0.45);
}

.profile_button_circle {
  display: none;
}

.profile_forgort {
  width: 100%;
  text-align: right;
  padding-right: 6px;
}

.profile_forgort a {
  color: #fff;
  text-transform: none;
}

.profile_sepatator {
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_sepatator div {
  height: 6px;
  width: 20%;
  background: #fff;
  border-radius: 50px;
}

.proile_social {
  display: flex;
  flex: 2;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  padding-top: 24px;
}
</style>